module.exports = __webpack_public_path__ + "img/share-pop.d1a812f0.png";